import { takeLatest, call, put } from 'redux-saga/effects';
import * as invitationActions from 'redux/ducks/Employee/InvitationDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';
import employeeApi from 'api/employee/employeeApi';
import employeeNoSessionApi from 'api/employee/employeeNoSessionApi';

export function* duplicateIdCheck({ payload }) {
  try {
    const response = yield call(employeeApi.duplicateIdCheck, payload);
    yield put(invitationActions.duplicateIdCheckSuccess({ ...response, ...payload }));
  } catch (error) {
    yield put(invitationActions.duplicateIdCheckFail(error));
  }
}
export function* getInviteLink({ payload }) {
  try {
    const response = yield call(employeeApi.getInviteLink, payload);
    yield put(invitationActions.getInviteLinkSuccess(response));
  } catch (error) {
    yield put(invitationActions.getInviteLinkFail(error));
  }
}
export function* checkOtp({ payload }) {
  try {
    const response = yield call(employeeNoSessionApi.checkOtp, payload);
    yield put(invitationActions.checkOtpSuccess(response));
  } catch (error) {
    // temp
    yield put(invitationActions.checkOtpFail(error));
  }
}

export function* createOtp({ payload }) {
  try {
    const response = yield call(employeeApi.createOtp, payload);
    yield put(invitationActions.createOtpSuccess(response));
  } catch (error) {
    // temp
    // yield put(alertActions.open({ message: [error.errorCode] }));
    yield put(invitationActions.createOtpFail(error));
  }
}

export function* createInviteEmp({ payload }) {
  try {
    const response = yield call(employeeApi.createInviteEmp, payload);
    yield put(invitationActions.createInviteEmpSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ isDimed: true, message: [error.errorCode] }));
  }
}

export default function* InvitationSaga() {
  yield takeLatest(invitationActions.duplicateIdCheck, duplicateIdCheck);
  yield takeLatest(invitationActions.getInviteLink, getInviteLink);
  yield takeLatest(invitationActions.checkOtp, checkOtp);
  yield takeLatest(invitationActions.createOtp, createOtp);
  yield takeLatest(invitationActions.createInviteEmp, createInviteEmp);
}
